import styled, { DefaultTheme } from 'styled-components';
import { Menu } from 'antd5';
import { FlexContainer } from 'utils/layouts/containers';
import { Sider } from 'components/ui';
import { Theme } from 'utils/color/horizonTheme';

export const Logo = styled(FlexContainer)`
  background: ${({ theme }) => theme.tertiaryBackgroundColor};
  text-align: center;
  overflow: hidden;
  height: 65px;
  justify-content: center;
  border-bottom: 1px solid ${({ theme }) => theme.borderColor};
`;

export const Image = styled.img<{ collapsed?: boolean }>`
  width: ${({ collapsed }) => (collapsed ? '64px' : '100%')};
  padding: 0.5em 1em;
`;

// !important for overriding antd
// Trevor: Not sure where the "margin-right: 10px" is coming from on the icon property
// for the Menu, but it causes a larger space between the icon and title than what we want.
// When inspecting the antd menu on their examples on the antd site. It does not have
// the "margin-right: 10px" property.
export const StyledMenu = styled(Menu)`
  width: 100%;
  .ant-menu-item {
    font-size: 16px !important;
  }
  .ant-menu-item .ant-menu-item-icon {
    margin-right: 0px;
  }

  .ant-menu-item-disabled {
    display: flex;

    svg {
      stroke: ${({ theme }) => theme.lightShadow} !important;
    }

    .ant-menu-title-content {
      display: inline-flex;
      flex-grow: 1;

      span {
        width: 100%;
      }
    }
  }
`;

/**
 * antd's Sider component has a 'theme' prop, so we need to rename
 * the styled-components theme prop here
 */
export const StyledSider = styled(Sider)<{ $styledComponentsTheme: DefaultTheme }>`
  background: ${({ $styledComponentsTheme }) =>
    $styledComponentsTheme.tertiaryBackgroundColor} !important;
  border-right: 1px solid ${({ $styledComponentsTheme }) => $styledComponentsTheme.borderColor};

  .ant-menu,
  .ant-menu-dark {
    background: ${({ $styledComponentsTheme }) =>
      $styledComponentsTheme.tertiaryBackgroundColor} !important;

    .ant-menu-item {
      color: ${({ $styledComponentsTheme }) => $styledComponentsTheme.headerColor} !important;

      > span > a {
        color: ${({ $styledComponentsTheme }) => $styledComponentsTheme.headerColor} !important;
      }

      ${({ $styledComponentsTheme }) =>
        $styledComponentsTheme.themeName === Theme.Dark &&
        `
        &.ant-menu-item-selected {
          background-color: ${$styledComponentsTheme.teal};
        }
      `}

      ${({ $styledComponentsTheme }) =>
        $styledComponentsTheme.themeName === Theme.Light &&
        `
          &.ant-menu-item-selected,
          &.ant-menu-item-selected > span > a {
            color: ${$styledComponentsTheme.teal} !important;
          }
      `}

      &:hover {
        background-color: ${({ $styledComponentsTheme }) =>
          $styledComponentsTheme.themeName === Theme.Dark
            ? $styledComponentsTheme.activeMenuItemBackgroundColor
            : $styledComponentsTheme.borderAccentColor} !important;
      }
    }
  }

  .ant-layout-sider-trigger {
    background: ${({ $styledComponentsTheme }) =>
      $styledComponentsTheme.themeName === Theme.Dark
        ? $styledComponentsTheme.primaryBackgroundColor
        : $styledComponentsTheme.gray} !important;
    border-right: 1px solid ${({ $styledComponentsTheme }) => $styledComponentsTheme.borderColor};

    svg {
      color: ${({ $styledComponentsTheme }) => $styledComponentsTheme.descriptionColor} !important;
    }
  }
`;
